import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { getInvestigationMetricsStateQuery } from "./investigation-metrics-state.operations";
import { IApiInvestigationMetricsStateConnection, IApiInvestigationMetricsFilter } from 'src/app/shared/modules/graphql/types/types';
import { IGqlBaseOptions } from "../../../../interfaces";
import { connectionQuery } from "../../../../helpers.class";

@Injectable()
export class GqlInvestigationMetricsStateService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationMetricsStateConnection> {
    return this.apollo.query(connectionQuery(getInvestigationMetricsStateQuery, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
